import { initReactI18next } from 'react-i18next';
import type { BackendModule, InitOptions } from 'i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import type { ApiAcceptedLanguage } from '@izimi/api';

export * from './helpers';

export const locales: Array<ApiAcceptedLanguage> = ['en', 'fr', 'nl', 'de'];

export const namespaces = [
  'communications',
  'errors',
  'historyLog',
  'shared',
  'trash',
  'naban',
  'notifications',
  'vaultTransfer',
  'sharing',
  'emailNotifications',
  'unsubscribe',
];

export const initializeI18n = (
  read: BackendModule['read'],
  {
    logMissing = false,
    onMissingKey,
  }: {
    logMissing?: boolean;
    onMissingKey?: (ns: string, key: string) => void;
  } = {},
  init?: InitOptions,
) =>
  i18n
    .use(LanguageDetector)
    .use<BackendModule>({
      type: 'backend',
      init() {},
      read,
    })
    .use(initReactI18next)
    .init({
      partialBundledLanguages: true,
      ns: ['shared'],
      supportedLngs: locales,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
      react: { useSuspense: true },
      debug: false,
      saveMissing: true,
      missingKeyHandler(_, ns, key) {
        if (typeof key !== 'string' || key.includes(' ') || key.includes('<') || i18n.exists(key)) {
          return;
        }

        onMissingKey?.(ns, key);

        if (logMissing) {
          // eslint-disable-next-line no-console
          console.log(`%c[i18n] ❌ MISSING: "${ns}:${key}"`, 'color: red; font-weight: bold;');
        }
      },
      ...init,
    });
